import _ from 'lodash';
import { LAUNCH_PENDO_GUIDE } from './actionTypes';

const PENDO_RETRY_MAX = 20;

/**
 * Midleware for launching pendo
 *
 * This middleware uses the `LAUNCH_PENDO_GUIDE` action, which contains a guide id. It uses this
 * id to launch the appropriate guide. The action kicks off an interval untill a pendo script is
 * finally loaded. If no guide exists with that id, nothing happens.
 */
const pendoMiddleware = () => (next) => (action) => {
  try {
    const { type, id } = action;
    if (type === LAUNCH_PENDO_GUIDE) {
      let retryCount = 0;
      const loadPendoGuide = (resolve, reject) => {
        if (window.pendo && window.pendo.guides) {
          const selectedGuide = _.find(window.pendo.guides, { id });
          resolve(selectedGuide && selectedGuide.launch());
        } else if (retryCount >= PENDO_RETRY_MAX) {
          reject('Pendo did not load in time');
        } else {
          setTimeout(() => {
            retryCount += 1;
            loadPendoGuide(resolve, reject);
          }, 300);
        }
      };

      new Promise(loadPendoGuide).then(
        () => null,
        (error) => {
          // We want to log this error so it shows up in the console
          console.error(error); // eslint-disable-line
        },
      );
    }
  } catch (error) {} // eslint-disable-line

  return next(action);
};

export default pendoMiddleware;
